export function SearchVideoProgress (video)
{

      video.errorlib = "";
      video.finish = true;
      var totalpc = 0;
      var pc = 0;
      var mustRefreshAssetsList = false;

        // on test l'etat de chacun des works

      // search datas
      switch (video.searchdata)
      {
        case -3: // fini
          totalpc = totalpc + 100;
          pc = pc + 100;
          break;
        case -2: // non demandé
          break;
        case -1: // en attente
          totalpc = totalpc + 100;
          mustRefreshAssetsList = true;
          video.finish = false;
          break;
        case 0: // en traitement
          totalpc = totalpc + 100;
          mustRefreshAssetsList = true;
          video.finish = false;
          break;
        default: // en erreur
          video.errorlib = video.vierrorlibsearch;
          break;
      }


      // conversion
      switch (video.viconv)
      {
        case -3: // fini
          totalpc = totalpc + 100;
          pc = pc + 100;
          break;
        case -2: // non demandé
          break;
        case -1: // en attente
          totalpc = totalpc + 100;
          mustRefreshAssetsList = true;
          video.finish = false;
          break;
        case 0: // en traitement
          totalpc = totalpc + 100;
          pc = pc + video.viconvpc
          mustRefreshAssetsList = true;
          video.finish = false;
          break;
        default: // en erreur
          video.errorlib = video.vierrorlibconv;
          break;
      }

      // audio
      switch (video.vixaudio)
      {
        case -3: // fini
          totalpc = totalpc + 100;
          pc = pc + 100;
          break;
        case -2: // non demandé
          break;
        case -1: // en attente
          totalpc = totalpc + 100;
          mustRefreshAssetsList = true;
          video.finish = false;
          break;
        case 0: // en traitement
          totalpc = totalpc + 100;
          pc = pc + video.vixaudiopc
          mustRefreshAssetsList = true;
          video.finish=false;
          break;
        default: // en erreur
          video.errorlib = video.vierrorlibaudio;
          break;
      }


      // changement de plan
      switch (video.vixcp)
      {
        case -3: // fini
          totalpc = totalpc + 100;
          pc = pc + 100;
          break;
        case -2: // non demandé
          break;
        case -1: // en attente
          totalpc = totalpc + 100;
          mustRefreshAssetsList = true;
          video.finish=false;
          break;
        case 0: // en traitement
          totalpc = totalpc + 100;
          pc = pc + video.vixcppc
          mustRefreshAssetsList = true;
          video.finish=false;
          break;
        default: // en erreur
          video.errorlib = video.vierrorlibcp;
          break;
      }

      // transcription
      switch (video.vixtr)
      {
        case -3: // fini
          totalpc = totalpc + 100;
          pc = pc + 100;
          break;
        case -2: // non demandé
          break;
        case -1: // en attente
          totalpc = totalpc + 100;
          mustRefreshAssetsList = true;
          video.finish=false;
          break;
        case 0: // en traitement
          totalpc = totalpc + 100;
          pc = pc + video.vixtrpc
          mustRefreshAssetsList = true;
          video.finish=false;
          break;
        default: // en erreur
          video.errorlib = video.vierrorlibtranscription;
          break;
      }

      // textes
      switch (video.vixtex)
      {
        case -3: // fini
          totalpc = totalpc + 100;
          pc = pc + 100;
          break;
        case -2: // non demandé
          break;
        case -1: // en attente
          totalpc = totalpc + 100;
          mustRefreshAssetsList = true;
          video.finish=false;
          break;
        case 0: // en traitement
          totalpc = totalpc + 100;
          pc = pc + video.vixtexpc
          mustRefreshAssetsList = true;
          video.finish=false;
          break;
        default: // en erreur
          video.errorlib = video.vierrorlibtex;
          break;
      }


      // scenario
      switch (video.visimp)
      {
        case -3: // fini
          totalpc = totalpc + 100;
          pc = pc + 100;
          break;
        case -2: // non demandé
          break;
        case -1: // en attente
          totalpc = totalpc + 100;
          mustRefreshAssetsList = true;
          video.finish=false;
          break;
        case 0: // en traitement
          totalpc = totalpc + 100;
          pc = pc + video.viscepc
          mustRefreshAssetsList = true;
          video.finish=false;
          break;
        default: // en erreur
          video.errorlib = video.vierrorlibsce;
          break;
      }




      // simplification
      switch (video.visimp)
      {
        case -3: // fini
          totalpc = totalpc + 100;
          pc = pc + 100;
          break;
        case -2: // non demandé
          break;
        case -1: // en attente
          totalpc = totalpc + 100;
          mustRefreshAssetsList = true;
          video.finish=false;
          break;
        case 0: // en traitement
          totalpc = totalpc + 100;
          pc = pc + video.visimppc
          mustRefreshAssetsList = true;
          video.finish=false;
          break;
        default: // en erreur
          video.errorlib = video.vierrorlibsimp;
          break;
      }


      video.totalpc = totalpc;
      video.pc = pc;

    return mustRefreshAssetsList;
}